module.exports = __webpack_public_path__ + "static/img/Itali.1d2fb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Itali.png
// module id = UGwD
// module chunks = 1